import { useCore } from '@/composables/core/index.js'

export default function () {
  const { store } = useCore()

  const url = '{base}/{language}-{country}/'
    .replace('{base}/', store.state.routingConfig?.config?.frontdesk_url)
    .replace('{language}', store.state.app?.language)
    .replace('{country}', store.state.app?.country)

  this.sendEvent('core.ehlo', {
    app_link: url,
    app_link_logout: `${url}logout`,
  })
}
